import { render, staticRenderFns } from "./Resetpsw.vue?vue&type=template&id=3cd0e53f&scoped=true"
import script from "./Resetpsw.vue?vue&type=script&lang=js"
export * from "./Resetpsw.vue?vue&type=script&lang=js"
import style0 from "./Resetpsw.vue?vue&type=style&index=0&id=3cd0e53f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0e53f",
  null
  
)

export default component.exports